const OSSKeyValueCell = ({ column, row, data }) => {
  const { dataKey } = column;
  const key = row[dataKey];
  const { valuesMap } = data;

  return valuesMap.get(key) || "";
};

export { OSSKeyValueCell };
